<template>
  <TIcon
    name="loader"
    size="16"
    class="origin-center animate-spin justify-center text-neutral-400"
  />
</template>
<script lang="ts" setup>
import TIcon from './Icon/TIcon.vue';
</script>
